import type { ValidatorFn } from '@angular/forms';
import { Validators } from '@angular/forms';

export const validateNonEmptyOrWhitespace = (): ValidatorFn => Validators.pattern(/^(?!\s*$).+/);
